import classNames from "classnames";
import React from "react";

import { ActionIcon } from "../action_icon";
import { Typography } from "../typography";
import css from "./side_panel.module.scss";

type Size = "default" | "large";

interface SidePanelProps {
  title?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  show: boolean;
  size?: Size;
  onClose: () => void;
  classes?: Partial<{ show: string }>;
  fullHeight?: boolean;
}

const SidePanel = ({
  title,
  actions,
  children,
  show,
  onClose,
  size = "default",
  classes = {},
  fullHeight
}: SidePanelProps): JSX.Element => (
  <div
    className={classNames(
      css.root,
      { [classes.show || css.show]: show },
      { [css.sizeDefault]: size === "default" },
      { [css.sizeLarge]: size === "large" },
      { [css.fullHeight]: fullHeight }
    )}
  >
    <div className={css.header}>
      {title && (
        <Typography noMargin variant="h4">
          {title}
        </Typography>
      )}
      <div className={css.actions}>
        {actions}
        <ActionIcon
          name="cross"
          color="paletteBlue0"
          size="sm"
          onClick={() => onClose()}
          classes={{ root: css.close }}
        />
      </div>
    </div>

    {children}
  </div>
);

export default SidePanel;
